import { render, staticRenderFns } from "./gantt-captures-modal.vue?vue&type=template&id=5c4510df"
import script from "./gantt-captures-modal.vue?vue&type=script&lang=js"
export * from "./gantt-captures-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports